import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function AdminProtected({ children }) {
    const { isAdminAuthenticated, loading } = useAdminAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div
                className="grid min-h-screen place-items-center bg-brand-charcoal text-brand-offwhite"
                data-testid="admin-protected-loading"
            >
                <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-gold">
                    Verifying admin session…
                </p>
            </div>
        );
    }

    if (!isAdminAuthenticated) {
        return (
            <Navigate
                to="/admin/login"
                replace
                state={{ from: location.pathname }}
            />
        );
    }

    return children;
}
